import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const inAppColorProfilesNRO: NavigationRoutingObject = {
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("in-app-message-templates", "In-App Message Templates"),
  pageNameForTracking: () => "In-App Message Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("in-app-message-templates-nav", "Create and manage custom message templates and color profiles"),
  icon: "nav-system-in-app-message-templates",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("iam");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("in-app-message-templates-alt-keyword-1", "IAM Templates")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
